import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Gift, ArrowLeft, Bell, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";

const GiftShopPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-[#FDF8F4] via-white to-[#F4F1EA]">
      {/* Header */}
      <header className="bg-white/80 backdrop-blur-sm border-b border-[#F4F1EA] sticky top-0 z-10">
        <div className="max-w-4xl mx-auto px-4 py-4 flex items-center justify-between">
          <Link to="/dashboard" className="flex items-center gap-2 text-[#6D6F7C] hover:text-[#3D405B]">
            <ArrowLeft className="w-5 h-5" />
            <span>Back</span>
          </Link>
          <h1 className="text-lg font-semibold text-[#3D405B]" style={{ fontFamily: 'Fraunces, serif' }}>
            Gift Shop
          </h1>
          <div className="w-16" /> {/* Spacer for centering */}
        </div>
      </header>

      {/* Coming Soon Content */}
      <main className="max-w-md mx-auto px-4 py-16 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          {/* Icon */}
          <div className="w-24 h-24 bg-gradient-to-br from-[#F2CC8F] to-[#E07A5F] rounded-full flex items-center justify-center mx-auto mb-8">
            <Gift className="w-12 h-12 text-white" />
          </div>

          {/* Headline */}
          <h2 
            className="text-3xl font-bold text-[#3D405B] mb-4"
            style={{ fontFamily: 'Fraunces, serif' }}
          >
            Gifts are coming soon
          </h2>

          {/* Subtext */}
          <p className="text-[#6D6F7C] mb-8 max-w-sm mx-auto">
            We&apos;re working on thoughtful ways to help you surprise the people you care about.
          </p>

          {/* Features preview */}
          <div className="bg-white rounded-2xl p-6 shadow-sm border border-[#F4F1EA] mb-8">
            <div className="flex items-center gap-2 text-[#E07A5F] mb-4">
              <Sparkles className="w-4 h-4" />
              <span className="text-sm font-medium">What&apos;s coming</span>
            </div>
            <ul className="text-left space-y-3 text-sm text-[#6D6F7C]">
              <li className="flex items-center gap-3">
                <span className="w-6 h-6 bg-[#F2CC8F]/20 rounded-full flex items-center justify-center text-xs">🎁</span>
                Digital gift cards for any occasion
              </li>
              <li className="flex items-center gap-3">
                <span className="w-6 h-6 bg-[#E07A5F]/10 rounded-full flex items-center justify-center text-xs">💐</span>
                Fresh flowers delivered to their door
              </li>
              <li className="flex items-center gap-3">
                <span className="w-6 h-6 bg-[#81B29A]/10 rounded-full flex items-center justify-center text-xs">✉️</span>
                Handwritten notes mailed for you
              </li>
            </ul>
          </div>

          {/* Back button */}
          <Link to="/dashboard">
            <Button 
              variant="outline" 
              className="rounded-full border-[#F4F1EA] hover:bg-[#F4F1EA]"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back to Dashboard
            </Button>
          </Link>
        </motion.div>
      </main>
    </div>
  );
};

export default GiftShopPage;
